// cspell:ignore Quikserve, valuelink
export const ProductComponentType = {
    Hardware: 'Hardware',
    PaymentIntegration: 'PaymentIntegration',
    PaymentTerminal: 'PaymentTerminal',
    StoredValueIntegration: 'StoredValueIntegration',
    PosIntegration: 'PosIntegration',
    LoyaltyIntegration: 'LoyaltyIntegration',
    // TODO: there are more here
};
export const PricePoint = {
    Low: '$',
    Medium: '$$',
    High: '$$$',
    VeryHigh: '$$$$',
};
export const Tier = {
    EOL: 'EOL',
    LabTested: 'Lab Tested',
    Bronze: 'Bronze',
    Silver: 'Silver',
    Gold: 'Gold',
};
export const HardwareManufacturer = {
    Acrelec: 'Acrelec',
    Apple: 'Apple',
    Elo: 'Elo',
    Flytech: 'Flytech',
    HP: 'HP',
    Lenovo: 'Lenovo',
    MicroTouch: 'MicroTouch',
    Posiflex: 'Posiflex',
    Samsung: 'Samsung',
    TouchDynamic: 'Touch Dynamic',
};
export const HardwarePeripheral = {
    Camera: 'Camera',
    HID: 'HID',
    MSR: 'MSR',
    ReceiptPrinter: 'Receipt Printer',
    Scale: 'Scale',
    Scanner: 'Scanner',
    StormAudioNav: 'Storm Audio Nav',
};
export const HardwareConfiguration = {
    Counter: 'Counter',
    FreeStanding: 'Free-standing',
    Linebuster: 'Linebuster',
    WallMounted: 'Wall-mounted',
};
export const HardwareOrientation = {
    Portrait: 'Portrait',
    Landscape: 'Landscape',
};
export const PaymentTerminalManufacturer = {
    Bbpos: 'BBPOS',
    Ingenico: 'Ingenico',
    Verifone: 'Verifone',
    Pax: 'PAX',
};
export const PaymentTerminalFeature = {
    Battery: 'battery',
    Outdoors: 'outdoors',
};
export const PaymentTerminalConnectionType = {
    Ethernet: 'Ethernet',
    USB: 'USB',
    WiFi: 'WiFi',
};
export const StoredValueProvider = {
    Atrium: 'Atrium',
    Eigen: 'Eigen',
    Elavon: 'Elavon',
    Givex: 'Givex',
    Heartland: 'Heartland/Archer',
    ItsOnMe: 'ItsOnMe',
    Moneris: 'Moneris/Ernex',
    NCR: 'NCR',
    Paytronix: 'Paytronix',
    Premier: 'Premier',
    Starbucks: 'Starbucks',
    STS: 'STS',
    SVS: 'SVS',
    Synergy: 'Synergy',
    TCC: 'TCC',
    Valuelink: 'Valuelink/Fiserv/FirstData',
    Valutec: 'Valutec',
    Worldpay: 'Worldpay/Vantiv',
};
export const PosProvider = {
    Infor: 'Infor',
    MicrosSimphonyGen1Api: 'Micros Simphony < v19.2',
    MicrosSimphonyGen2Api: 'Micros Simphony v19.2+',
    MicrosRes3700: 'Micros RES 3700',
    NcrAloha: 'NCR Aloha',
    NcrRadiant: 'NCR Radiant',
    Otter: 'Otter',
    PanasonicIqTouch: 'Panasonic IQ Touch',
    ParBrink: 'Par Brink',
    PDI: 'PDI',
    Qu: 'Qu',
    QuikServe: 'QuikServe',
    Revel: 'Revel',
    Salido: 'Salido',
    SpotOn: 'SpotOn',
    Square: 'Square',
    Squirrel: 'Squirrel',
    Toast: 'Toast',
    Upserve: 'Upserve/Breadcrumb',
    VerifoneCommander: 'Verifone Commander',
    Starbucks: 'Starbucks',
};
export const LoyaltyProvider = {
    Appfront: 'Appfront',
    Atrium: 'Atrium',
    Cheetah: 'Cheetah',
    ChoptLoyalty: 'Chopt Loyalty',
    Como: 'Como',
    Givex: 'Givex',
    Incentivio: 'Incentivio',
    LoyaltyPlant: 'LoyaltyPlant',
    Lunchbox: 'Lunchbox',
    MyLovesRewards: 'My Loves Rewards',
    OloAccounts: 'Olo Accounts',
    Paytronix: 'Paytronix',
    Punchh: 'Punchh',
    SessionM: 'SessionM',
    SmoothCommerce: 'Smooth Commerce',
    Sparkfly: 'Sparkfly',
    Spendgo: 'Spendgo',
    Starbucks: 'Starbucks',
    Thanx: 'Thanx',
};
//# sourceMappingURL=schema.js.map